import { Link } from "react-router-dom";
import { trackEmptyClassicClicked } from "@/daily/analytics";
import { DESKTOP_QUERY, useMediaQuery } from "@/daily/hooks";
import { dt } from "@/daily/strings";
import { FitText } from "./FitText";
import { ArrowIcon, PlaneIcon } from "./icons";

// Shown when there is no puzzle to play: a card on the map's paper, with a
// way on to the classic game.
export const EmptyScreen = () => {
  const isDesktop = useMediaQuery(DESKTOP_QUERY);

  return (
    <div className="ds ds-empty">
      <div className="ds-empty__card">
        <span className="ds-empty__badge" aria-hidden="true">
          <PlaneIcon size={26} />
        </span>
        <span className="ds-eyebrow ds-eyebrow--red ds-empty__eyebrow">
          Daily Service
        </span>
        <h1 className="ds-empty__title">
          <FitText max={isDesktop ? 44 : 36} min={24}>
            {dt("emptyTitle")}
          </FitText>
        </h1>
        <p className="ds-empty__text">
          {dt("emptyText")}
        </p>
        <hr className="ds-empty__rule" />
        <Link
          to="/"
          onClick={trackEmptyClassicClicked}
          className="ds-button ds-button--red ds-empty__button"
        >
          <FitText max={15} min={9}>
            {dt("classic")}
          </FitText>
          <ArrowIcon size={18} />
        </Link>
      </div>
    </div>
  );
};
